<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>{{type==='待审核'?'试课审核':'试课详情'}}</span>
            </div>
            <div class="right"></div>
        </div>
        <div class="main">
			<div class="main-li" v-for="(item,i) in list" :key="i+item.title">
				<p>{{item.title}}</p>
				<span>{{item.text}}</span>
			</div>
			<div class="main-li" v-if="type!=='待审核'">
				<p>试课结果</p>
				<span>{{type==='审核不通过'?'不通过':'通过'}}</span>
			</div>
			<div class="main-li" v-if="type!=='待审核'">
				<p>反馈时间</p>
				<span>2021-11-22  17:22</span>
			</div>
		</div>
		<footer v-if="type==='待审核'">
			<el-button style="width:120px;" size="small" @click='toHandle("3")'>不通过</el-button>
			<el-button style="width:120px;margin-left:20px;" type="primary" size="small" @click='toHandle("2")'>通过</el-button>
	    </footer>
    </div>
</template>
<script>
import educationApi from '@/api/education/index.js'
export default {
	props:['info','type'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [],
			list:[
				{title:'课程名称',text:''},
				{title:'课程分类',text:''},
				{title:'所属机构',text:''},
				{title:'申请学校',text:''},
				{title:'申请人',text:''},
				{title:'联系电话',text:''},
			],
		}
	},
	computed:{

	},
	watch: {
		info:{
			handler(n,o){
				const vm = this.info;
				this.list = [
					{title:'课程名称',text:vm.cname},
					{title:'课程分类',text:vm.typeName},
					{title:'所属机构',text:vm.parentOrgName},
					{title:'申请学校',text:vm.applyOrgName},
					{title:'申请人',text:vm.proposer},
					{title:'联系电话',text:vm.phone},
				]
			},
			deep:true
		}
	},
	created() {
		
	},
	methods: {
        toIndex(){
            this.$emit('to-index')
        },
		async toHandle(state){
			let params={
				aid:this.info.aid,
				auditState:state,
			}
			let res=await educationApi.educationCourseAttemptaudit(params);
			if (res.result == "000000") {
				this.$message({type: "success",message: "操作成功",});
				this.$emit('to-init');
				this.toIndex();
			} else {
				this.$message({type: "error",message: "操作失败",});
			}
		},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.main{
		width: 100%;
		height: 100%;
		.main-title{
			display: flex;
			align-items: center;
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
		.main-li{
			margin-top: 20px;
			width: 100%;
			display: flex;
			// align-items: center;
			font-size: 14px;
			color: #888;
			p{
				width: 120px;
				text-align: right;
				margin-right: 20px;
			}
			span{
				width: calc(100% - 150px);
				word-wrap:break-word;
			}
		}
	}
}
footer{
	margin-top: 50px;
	display: flex;
	justify-content: center;
}
</style>
